// import mapping
import {WazarenTagsMapping} from "./mappings/wazarenTags";
import {PlaceCategoriesMapping, PlaceTagsMapping} from "./mappings/placeCategories";

// constants.js

// General
let ENGLISH = "en"
let JAPANESE = "jp"
let TRADITIONAL_CHINESE = "tc"
let SIMPLIFIED_CHINESE = "sc"


export const LANGUAGE_ABBR = {
    ENGLISH: ENGLISH,
    JAPANESE: JAPANESE,
    TRADITIONAL_CHINESE: TRADITIONAL_CHINESE,
    SIMPLIFIED_CHINESE: SIMPLIFIED_CHINESE,
}

export const LANGUAGE_LIST = [
    ENGLISH,
    JAPANESE,
    TRADITIONAL_CHINESE, 
    SIMPLIFIED_CHINESE,
]

export const TITLE = "Wotagei Zone";

export const APP_BAR = {
    LANGUAGE_OPTION: {
        [ENGLISH]: "Eng",
        [JAPANESE]: "日",
        [TRADITIONAL_CHINESE]: "繁",
        [SIMPLIFIED_CHINESE]: "簡",
    },
    LOGIN: {
        [ENGLISH]: "Login",
        [JAPANESE]: "ログイン",
        [TRADITIONAL_CHINESE]: "登入",
        [SIMPLIFIED_CHINESE]: "登入",
    },
    REGISTER: {
        [ENGLISH]: "Sign Up",
        [JAPANESE]: "登録する",
        [TRADITIONAL_CHINESE]: "登記",
        [SIMPLIFIED_CHINESE]: "登记",
    },
    USER_MENU: {
        PROFILE: {
            [ENGLISH]: "Profile",
            [JAPANESE]: "プロフィール",
            [TRADITIONAL_CHINESE]: "用戶資料",
            [SIMPLIFIED_CHINESE]: "用戶资料",
        },
        SETTING: {
            [ENGLISH]: "Setting",
            [JAPANESE]: "設定",
            [TRADITIONAL_CHINESE]: "設定",
            [SIMPLIFIED_CHINESE]: "設定",
        },
        LOGOUT: {
            [ENGLISH]: "Logout",
            [JAPANESE]: "ログアウト",
            [TRADITIONAL_CHINESE]: "登出",
            [SIMPLIFIED_CHINESE]: "登出",
        },
    }
}

// Drawer.js
export const DRAWER = {
    TOPIC: {
        [ENGLISH]: "Topic",
        [JAPANESE]: "トピック",
        [TRADITIONAL_CHINESE]: "主題",
        [SIMPLIFIED_CHINESE]: "主题",
    },
    HOME: {
        [ENGLISH]: "Home",
        [JAPANESE]: "ホーム",
        [TRADITIONAL_CHINESE]: "主頁",
        [SIMPLIFIED_CHINESE]: "主页",
    },
    TERMS_EXPLAINED: {
        [ENGLISH]: "Terms Explained",
        [JAPANESE]: "用語解説",
        [TRADITIONAL_CHINESE]: "術語解釋",
        [SIMPLIFIED_CHINESE]: "术语解释",
    },
    CONTACT_US: {
        [ENGLISH]: "Contact Us",
        [JAPANESE]: "お問い合わせ",
        [TRADITIONAL_CHINESE]: "聯絡我們",
        [SIMPLIFIED_CHINESE]: "联系我们",
    },
    WAZAREN: {
        [ENGLISH]: "Wazaren",
        [JAPANESE]: "サビ技",
        [TRADITIONAL_CHINESE]: "副歌技",
        [SIMPLIFIED_CHINESE]: "副歌技",
    },
    WOTAGEISHI: {
        [ENGLISH]: "Wotageishi",
        [JAPANESE]: "ヲタ芸師",
        [TRADITIONAL_CHINESE]: "御宅藝師",
        [SIMPLIFIED_CHINESE]: "御宅艺师",
    },
    ORGANIZATION: {
        [ENGLISH]: "Organization",
        [JAPANESE]: "団体",
        [TRADITIONAL_CHINESE]: "組織",
        [SIMPLIFIED_CHINESE]: "组织",
    },
    MOVEMENT: {
        [ENGLISH]: "Movement",
        [JAPANESE]: "アクション",
        [TRADITIONAL_CHINESE]: "動作",
        [SIMPLIFIED_CHINESE]: "动作",
    },
    PLACE: {
        [ENGLISH]: "Places",
        [JAPANESE]: "打師常去地",
        [TRADITIONAL_CHINESE]: "打師常去地",
        [SIMPLIFIED_CHINESE]: "打师常去地",
    },
    REQUEST_TOPIC: {
        [ENGLISH]: "Request Topic",
        [JAPANESE]: "リクエストトピック",
        [TRADITIONAL_CHINESE]: "請求主題",
        [SIMPLIFIED_CHINESE]: "请求主题",
    },
    ADMIN: {
        [ENGLISH]: "Admin",
        [JAPANESE]: "管理者",
        [TRADITIONAL_CHINESE]: "管理員",
        [SIMPLIFIED_CHINESE]: "管理员",
    },
    APPROVE_TOPIC: {
        [ENGLISH]: "Approve Topic",
        [JAPANESE]: "トピックを承認する",
        [TRADITIONAL_CHINESE]: "批准主題",
        [SIMPLIFIED_CHINESE]: "批准主题",
    },

}

// UserSetting.js
export const USER_SETTING = {
    CATEGORY: {
        GENERAL: {
            [ENGLISH]: "General",
            [JAPANESE]: "一般",
            [TRADITIONAL_CHINESE]: "一般",
            [SIMPLIFIED_CHINESE]: "一般",
        }
    },
    ITEM: {
        DARK_MODE: {
            [ENGLISH]: "Dark Mode",
            [JAPANESE]: "ダークモード",
            [TRADITIONAL_CHINESE]: "深色模式",
            [SIMPLIFIED_CHINESE]: "深色模式",
        }
    }
}

// Home.js
export const HOME = {
    WE_RECORDED: {
        [ENGLISH]: "We recorded:",
        [JAPANESE]: "私たちは収録しました:",
        [TRADITIONAL_CHINESE]: "我們收錄了:",
        [SIMPLIFIED_CHINESE]: "我们收录了:",
    },
    WAZARENS: {
        [ENGLISH]: "Wazarens",
        [JAPANESE]: "サビ技",
        [TRADITIONAL_CHINESE]: "副歌技",
        [SIMPLIFIED_CHINESE]: "副歌技",
    },
    WOTAGEISHIS: {
        [ENGLISH]: "Wotageishis",
        [JAPANESE]: "ヲタ芸師",
        [TRADITIONAL_CHINESE]: "御宅藝師",
        [SIMPLIFIED_CHINESE]: "御宅艺师",
    },
    ORGANIZATIONS: {
        [ENGLISH]: "Organizations",
        [JAPANESE]: "団体",
        [TRADITIONAL_CHINESE]: "組織",
        [SIMPLIFIED_CHINESE]: "组织",
    },
    MOVEMENTS: {
        [ENGLISH]: "Movements",
        [JAPANESE]: "アクション",
        [TRADITIONAL_CHINESE]: "動作",
        [SIMPLIFIED_CHINESE]: "动作",
    },
    PLACES: {
        [ENGLISH]: "Places",
        [JAPANESE]: "打師常去地",
        [TRADITIONAL_CHINESE]: "打師常去地",
        [SIMPLIFIED_CHINESE]: "打师常去地",
    },
    COLLABORATING_WITH: {
        [ENGLISH]: "Collaborating with:",
        [JAPANESE]: "連携と協力:",
        [TRADITIONAL_CHINESE]: "協同合作:",
        [SIMPLIFIED_CHINESE]: "協同合作:",
    },
    REGIONS: {
        [ENGLISH]: "Regions",
        [JAPANESE]: "地域",
        [TRADITIONAL_CHINESE]: "地區",
        [SIMPLIFIED_CHINESE]: "地区",
    },
    HERO_TITLE: {
        [ENGLISH]: "Wotagei Zone",
        [JAPANESE]: "ヲタ芸ゾーン",
        [TRADITIONAL_CHINESE]: "御宅藝區",
        [SIMPLIFIED_CHINESE]: "御宅艺区",
    },
    HERO_SUBTITLE: {
        [ENGLISH]: "The ultimate platform for the wotagei community to search, discover, and connect",
        [JAPANESE]: "ヲタ芸コミュニティが検索、発見、交流するための究極のプラットフォーム",
        [TRADITIONAL_CHINESE]: "御宅藝社群搜尋、發現和連結的終極平台",
        [SIMPLIFIED_CHINESE]: "御宅艺社群搜索、发现和连接的终极平台",
    },
    DISCOVER_WAZAREN: {
        [ENGLISH]: "Discover Wazaren",
        [JAPANESE]: "サビ技を発見",
        [TRADITIONAL_CHINESE]: "發現副歌技",
        [SIMPLIFIED_CHINESE]: "发现副歌技",
    },
    FIND_WOTAGEISHI: {
        [ENGLISH]: "Find Wotageishi",
        [JAPANESE]: "ヲタ芸師を探す",
        [TRADITIONAL_CHINESE]: "尋找御宅藝師",
        [SIMPLIFIED_CHINESE]: "寻找御宅艺师",
    },
    JOIN_ORGANIZATIONS: {
        [ENGLISH]: "Join Organizations",
        [JAPANESE]: "団体に参加",
        [TRADITIONAL_CHINESE]: "加入組織",
        [SIMPLIFIED_CHINESE]: "加入组织",
    },
    READY_TO_EXPLORE: {
        [ENGLISH]: "Ready to explore the wotagei world?",
        [JAPANESE]: "ヲタ芸の世界を探索する準備はできましたか？",
        [TRADITIONAL_CHINESE]: "準備好探索御宅藝世界了嗎？",
        [SIMPLIFIED_CHINESE]: "准备好探索御宅艺世界了吗？",
    },
    START_EXPLORING: {
        [ENGLISH]: "Start Exploring",
        [JAPANESE]: "探索を始める",
        [TRADITIONAL_CHINESE]: "開始探索",
        [SIMPLIFIED_CHINESE]: "开始探索",
    },
    LEARN_MORE: {
        [ENGLISH]: "Learn More",
        [JAPANESE]: "詳細を見る",
        [TRADITIONAL_CHINESE]: "了解更多",
        [SIMPLIFIED_CHINESE]: "了解更多",
    }
}

// Contact Us Page
export const CONTACT_US = {
    TITLE: {
        [ENGLISH]: "Contact Us",
        [JAPANESE]: "お問い合わせ",
        [TRADITIONAL_CHINESE]: "聯絡我們",
        [SIMPLIFIED_CHINESE]: "联系我们",
    },
    SUBTITLE: {
        [ENGLISH]: "We'd love to hear from you! Reach out to us for any questions, suggestions, or feedback.",
        [JAPANESE]: "ご質問、ご提案、ご意見などございましたら、お気軽にお問い合わせください。",
        [TRADITIONAL_CHINESE]: "我們很樂意聽取您的意見！如有任何問題、建議或反饋，請隨時與我們聯繫。",
        [SIMPLIFIED_CHINESE]: "我们很乐意听取您的意见！如有任何问题、建议或反馈，请随时与我们联系。",
    },
    EMAIL_TITLE: {
        [ENGLISH]: "Email",
        [JAPANESE]: "メール",
        [TRADITIONAL_CHINESE]: "電子郵件",
        [SIMPLIFIED_CHINESE]: "电子邮件",
    },
    EMAIL_DESCRIPTION: {
        [ENGLISH]: "Send us an email and we'll get back to you as soon as possible.",
        [JAPANESE]: "メールをお送りいただければ、できるだけ早くご返信いたします。",
        [TRADITIONAL_CHINESE]: "請發送電子郵件給我們，我們會盡快回覆您。",
        [SIMPLIFIED_CHINESE]: "请发送电子邮件给我们，我们会尽快回复您。",
    },
    FOLLOW_US: {
        [ENGLISH]: "Follow Us",
        [JAPANESE]: "フォローする",
        [TRADITIONAL_CHINESE]: "追蹤我們",
        [SIMPLIFIED_CHINESE]: "关注我们",
    },
    FOLLOW_DESCRIPTION: {
        [ENGLISH]: "Stay connected with us on social media for the latest updates and community news.",
        [JAPANESE]: "ソーシャルメディアで私たちをフォローして、最新情報やコミュニティニュースをお見逃しなく。",
        [TRADITIONAL_CHINESE]: "在社交媒體上關注我們，獲取最新動態和社區消息。",
        [SIMPLIFIED_CHINESE]: "在社交媒体上关注我们，获取最新动态和社区消息。",
    },
}

// Terms Explained Page
export const TERMS_EXPLAINED_PAGE = {
    HERO_SUBTITLE: {
        [ENGLISH]: "Learn about the terminology and concepts used in the wotagei community",
        [JAPANESE]: "ヲタ芸コミュニティで使用される用語と概念について学ぶ",
        [TRADITIONAL_CHINESE]: "了解御宅藝社群中使用的術語和概念",
        [SIMPLIFIED_CHINESE]: "了解御宅艺社群中使用的术语和概念",
    },
    NO_TERMS_FOUND: {
        [ENGLISH]: "No terms found in this category",
        [JAPANESE]: "このカテゴリに用語が見つかりません",
        [TRADITIONAL_CHINESE]: "此類別中未找到術語",
        [SIMPLIFIED_CHINESE]: "此类别中未找到术语",
    }
}

// TermsExplained.js
export const TERMS_EXPLAINED = {
    ALL: {
        [ENGLISH]: "All",
        [JAPANESE]: "全",
        [TRADITIONAL_CHINESE]: "全部",
        [SIMPLIFIED_CHINESE]: "全部",
    }
}

// WazarenFilter.js
export const WAZAREN_FILTER = {
    FILTER: {
        [ENGLISH]: "Filter",
        [JAPANESE]: "フィルター",
        [TRADITIONAL_CHINESE]: "篩選",
        [SIMPLIFIED_CHINESE]: "筛选",
    },
    SKILL_NAME: {
        [ENGLISH]: "Wazaren Name",
        [JAPANESE]: "技名",
        [TRADITIONAL_CHINESE]: "技名",
        [SIMPLIFIED_CHINESE]: "技名",
    },
    SKILL_NAME_PLACEHOLDER: {
        [ENGLISH]: "Enter wazaren name...",
        [JAPANESE]: "スキル名を入力...",
        [TRADITIONAL_CHINESE]: "輸入技能名稱...",
        [SIMPLIFIED_CHINESE]: "输入技能名称...",
    },
    CREATOR_PLACEHOLDER: {
        [ENGLISH]: "Enter creator name...",
        [JAPANESE]: "作成者名を入力してください...",
        [TRADITIONAL_CHINESE]: "輸入創作者姓名...",
        [SIMPLIFIED_CHINESE]: "输入创作者姓名...",
    },
    TAGS: {
        [ENGLISH]: "Tags",
        [JAPANESE]: "タグ",
        [TRADITIONAL_CHINESE]: "標簽",
        [SIMPLIFIED_CHINESE]: "标签",
    },
    INCLUDE: {
        [ENGLISH]: "Include",
        [JAPANESE]: "含む",
        [TRADITIONAL_CHINESE]: "包括",
        [SIMPLIFIED_CHINESE]: "包括",
    },
    EXCLUDE: {
        [ENGLISH]: "Exclude",
        [JAPANESE]: "除外",
        [TRADITIONAL_CHINESE]: "排除",
        [SIMPLIFIED_CHINESE]: "排除",
    },
    RESET: {
        [ENGLISH]: "Reset",
        [JAPANESE]: "リセット",
        [TRADITIONAL_CHINESE]: "重設",
        [SIMPLIFIED_CHINESE]: "重设",
    },
    SEARCH: {
        [ENGLISH]: "Search",
        [JAPANESE]: "検索",
        [TRADITIONAL_CHINESE]: "搜索",
        [SIMPLIFIED_CHINESE]: "搜索",
    },
    SORTING_OPTION: {
        [ENGLISH]: "Sorting Option",
        [JAPANESE]: "並べ替えオプション",
        [TRADITIONAL_CHINESE]: "排序選項",
        [SIMPLIFIED_CHINESE]: "排序选项",
    },
    SEARCHING_OPTION: {
        [ENGLISH]: "Searching Option",
        [JAPANESE]: "検索オプション",
        [TRADITIONAL_CHINESE]: "搜尋選項",
        [SIMPLIFIED_CHINESE]: "搜索选项",
    }
}

// Place Filter
export const PLACE_FILTER = {
    FILTER: {
        [ENGLISH]: "Filter",
        [JAPANESE]: "フィルター",
        [TRADITIONAL_CHINESE]: "篩選",
        [SIMPLIFIED_CHINESE]: "筛选",
    },
    PLACE_NAME: {
        [ENGLISH]: "Place Name",
        [JAPANESE]: "場所名",
        [TRADITIONAL_CHINESE]: "場所名稱",
        [SIMPLIFIED_CHINESE]: "场所名称",
    },
    PLACE_NAME_PLACEHOLDER: {
        [ENGLISH]: "Enter place name...",
        [JAPANESE]: "場所名を入力...",
        [TRADITIONAL_CHINESE]: "輸入場所名稱...",
        [SIMPLIFIED_CHINESE]: "输入场所名称...",
    },
    LOCATION: {
        [ENGLISH]: "Location",
        [JAPANESE]: "位置",
        [TRADITIONAL_CHINESE]: "位置",
        [SIMPLIFIED_CHINESE]: "位置",
    },
    LOCATION_PLACEHOLDER: {
        [ENGLISH]: "Enter location...",
        [JAPANESE]: "位置を入力...",
        [TRADITIONAL_CHINESE]: "輸入位置...",
        [SIMPLIFIED_CHINESE]: "输入位置...",
    },
    CATEGORY: {
        [ENGLISH]: "Category",
        [JAPANESE]: "カテゴリー",
        [TRADITIONAL_CHINESE]: "類別",
        [SIMPLIFIED_CHINESE]: "类别",
    },
    TAGS: {
        [ENGLISH]: "Tags",
        [JAPANESE]: "タグ",
        [TRADITIONAL_CHINESE]: "標簽",
        [SIMPLIFIED_CHINESE]: "标签",
    },
    INCLUDE: {
        [ENGLISH]: "Include",
        [JAPANESE]: "含む",
        [TRADITIONAL_CHINESE]: "包括",
        [SIMPLIFIED_CHINESE]: "包括",
    },
    EXCLUDE: {
        [ENGLISH]: "Exclude",
        [JAPANESE]: "除外",
        [TRADITIONAL_CHINESE]: "排除",
        [SIMPLIFIED_CHINESE]: "排除",
    },
    RESET: {
        [ENGLISH]: "Reset",
        [JAPANESE]: "リセット",
        [TRADITIONAL_CHINESE]: "重設",
        [SIMPLIFIED_CHINESE]: "重设",
    },
    SEARCH: {
        [ENGLISH]: "Search",
        [JAPANESE]: "検索",
        [TRADITIONAL_CHINESE]: "搜索",
        [SIMPLIFIED_CHINESE]: "搜索",
    },
    SORTING_OPTION: {
        [ENGLISH]: "Sorting Option",
        [JAPANESE]: "並べ替えオプション",
        [TRADITIONAL_CHINESE]: "排序選項",
        [SIMPLIFIED_CHINESE]: "排序选项",
    },
    SEARCHING_OPTION: {
        [ENGLISH]: "Searching Option",
        [JAPANESE]: "検索オプション",
        [TRADITIONAL_CHINESE]: "搜尋選項",
        [SIMPLIFIED_CHINESE]: "搜索选项",
    },
    ALL_CATEGORIES: {
        [ENGLISH]: "All Categories",
        [JAPANESE]: "すべてのカテゴリー",
        [TRADITIONAL_CHINESE]: "所有類別",
        [SIMPLIFIED_CHINESE]: "所有类别",
    },
    QUICK_FILTERS: {
        [ENGLISH]: "Quick Filters",
        [JAPANESE]: "クイックフィルター",
        [TRADITIONAL_CHINESE]: "快速篩選",
        [SIMPLIFIED_CHINESE]: "快速筛选",
    },
    WOTAGEI_PLAYING: {
        [ENGLISH]: "Wotagei Playing",
        [JAPANESE]: "ヲタ芸練習",
        [TRADITIONAL_CHINESE]: "御宅藝練習",
        [SIMPLIFIED_CHINESE]: "御宅艺练习",
    },
    DINING: {
        [ENGLISH]: "Dining",
        [JAPANESE]: "食事",
        [TRADITIONAL_CHINESE]: "用餐",
        [SIMPLIFIED_CHINESE]: "用餐",
    },
    ENTERTAINMENT: {
        [ENGLISH]: "Entertainment",
        [JAPANESE]: "エンターテイメント",
        [TRADITIONAL_CHINESE]: "娛樂",
        [SIMPLIFIED_CHINESE]: "娱乐",
    },
    OUTDOOR: {
        [ENGLISH]: "Outdoor",
        [JAPANESE]: "屋外",
        [TRADITIONAL_CHINESE]: "戶外",
        [SIMPLIFIED_CHINESE]: "户外",
    }
}

// Place Details
export const PLACE_DETAILS = {
    LOCATION: {
        [ENGLISH]: "Location",
        [JAPANESE]: "位置",
        [TRADITIONAL_CHINESE]: "位置",
        [SIMPLIFIED_CHINESE]: "位置",
    },
    ADDRESS: {
        [ENGLISH]: "Address",
        [JAPANESE]: "住所",
        [TRADITIONAL_CHINESE]: "地址",
        [SIMPLIFIED_CHINESE]: "地址",
    },
    CATEGORY: {
        [ENGLISH]: "Category",
        [JAPANESE]: "カテゴリー",
        [TRADITIONAL_CHINESE]: "類別",
        [SIMPLIFIED_CHINESE]: "类别",
    },
    DESCRIPTION: {
        [ENGLISH]: "Description",
        [JAPANESE]: "詳情",
        [TRADITIONAL_CHINESE]: "詳情",
        [SIMPLIFIED_CHINESE]: "詳情",
    },
    POPULAR_TIMES: {
        [ENGLISH]: "Popular Times",
        [JAPANESE]: "人気の時間",
        [TRADITIONAL_CHINESE]: "熱門時段",
        [SIMPLIFIED_CHINESE]: "热门时段",
    },
    PHOTOS: {
        [ENGLISH]: "Photos",
        [JAPANESE]: "写真",
        [TRADITIONAL_CHINESE]: "照片",
        [SIMPLIFIED_CHINESE]: "照片",
    },
    MAP: {
        [ENGLISH]: "Map",
        [JAPANESE]: "地図",
        [TRADITIONAL_CHINESE]: "地圖",
        [SIMPLIFIED_CHINESE]: "地图",
    }
}

export const WAZAREN_TAGS = WazarenTagsMapping;
export const PLACE_CATEGORIES = PlaceCategoriesMapping;
export const PLACE_TAGS = PlaceTagsMapping;


// Wazaren Details
export const WAZAREN_DETAILS = {
    CREATOR: {
        [ENGLISH]: "Creator",
        [JAPANESE]: "クリエイター",
        [TRADITIONAL_CHINESE]: "作者",
        [SIMPLIFIED_CHINESE]: "作者",
    },
    EDITOR: {
        [ENGLISH]: "Editor",
        [JAPANESE]: "编集者",
        [TRADITIONAL_CHINESE]: "編輯者",
        [SIMPLIFIED_CHINESE]: "编辑者",
    },
    DATE_CREATED: {
        [ENGLISH]: "Date Created",
        [JAPANESE]: "建立日期",
        [TRADITIONAL_CHINESE]: "建立日期",
        [SIMPLIFIED_CHINESE]: "建立日期",
    },
    DESCRIPTION: {
        [ENGLISH]: "Description",
        [JAPANESE]: "詳情",
        [TRADITIONAL_CHINESE]: "詳情",
        [SIMPLIFIED_CHINESE]: "詳情",
    },
    VIDEO: {
        [ENGLISH]: "Video",
        [JAPANESE]: "視頻",
        [TRADITIONAL_CHINESE]: "影片",
        [SIMPLIFIED_CHINESE]: "視頻",
    },
    SOURCE: {
        [ENGLISH]: "Source",
        [JAPANESE]: "源",
        [TRADITIONAL_CHINESE]: "來源",
        [SIMPLIFIED_CHINESE]: "来源",
    },
}

// Wotageishi Filter
export const WOTAGEISHI_FILTER = {
    COUNTRY: {
        [ENGLISH]: "Country",
        [JAPANESE]: "国家",
        [TRADITIONAL_CHINESE]: "國家",
        [SIMPLIFIED_CHINESE]: "国家",
    },
    EXPERIENCE: {
        [ENGLISH]: "Experience (Years)",
        [JAPANESE]: "経験（年）",
        [TRADITIONAL_CHINESE]: "經驗（年）",
        [SIMPLIFIED_CHINESE]: "经验（年）",
    },
    NAME_PLACEHOLDER: {
        [ENGLISH]: "Enter Name...",
        [JAPANESE]: "名前を入力してください...",
        [TRADITIONAL_CHINESE]: "輸入名稱...",
        [SIMPLIFIED_CHINESE]: "输入名称...",
    },
}

// Wotageishi Details
export const WOTAGEISHI_DETAILS = {
    EXPERIENCE: {
        [ENGLISH]: "Experience",
        [JAPANESE]: "経験",
        [TRADITIONAL_CHINESE]: "經驗",
        [SIMPLIFIED_CHINESE]: "经验",
    },
    REMARK: {
        [ENGLISH]: "Remarks",
        [JAPANESE]: "述べる",
        [TRADITIONAL_CHINESE]: "備注",
        [SIMPLIFIED_CHINESE]: "笔记",
    },
    FAMOUS_WAZAREN: {
        [ENGLISH]: "Famous Wazaren",
        [JAPANESE]: "有名なサビ技",
        [TRADITIONAL_CHINESE]: "著名的副歌技",
        [SIMPLIFIED_CHINESE]: "著名的副歌技",
    },
    MARKINGS: {
        [ENGLISH]: "Markings",
        [JAPANESE]: "マーキング",
        [TRADITIONAL_CHINESE]: "標記",
        [SIMPLIFIED_CHINESE]: "标记",
    },
    SOCIAL_MEDIA: {
        [ENGLISH]: "Social Media",
        [JAPANESE]: "ソーシャルメディア",
        [TRADITIONAL_CHINESE]: "社群媒體",
        [SIMPLIFIED_CHINESE]: "社交媒体",
    },
    ORGANIZATION: {
        [ENGLISH]: "Organization",
        [JAPANESE]: "団体",
        [TRADITIONAL_CHINESE]: "組織",
        [SIMPLIFIED_CHINESE]: "组织",
    }
}

// Organization Filter
export const ORGANIZATION_FILTER = {
    NAME: {
        [ENGLISH]: "Name",
        [JAPANESE]: "名前",
        [TRADITIONAL_CHINESE]: "名稱",
        [SIMPLIFIED_CHINESE]: "名称",
    }
}

export const ORGANIZATION_DETAILS = {
    TEAM_LEADER: {
        [ENGLISH]: "Team Leader",
        [JAPANESE]: "チームリーダー",
        [TRADITIONAL_CHINESE]: "隊長",
        [SIMPLIFIED_CHINESE]: "队长",
    },
    KEY_MEMBERS: {
        [ENGLISH]: "Key Members",
        [JAPANESE]: "キーメンバー",
        [TRADITIONAL_CHINESE]: "主要成員",
        [SIMPLIFIED_CHINESE]: "主要成员",
    }
}

export const MOVEMENT_FILTER = {
    CATEGORIES: {
        [ENGLISH]: "Categories",
        [JAPANESE]: "カテゴリー",
        [TRADITIONAL_CHINESE]: "類別",
        [SIMPLIFIED_CHINESE]: "类别",
    },
}

// Request Topic
export const REQUEST_TOPIC = {
    HOME: {
        WAZAREN_MSG: {
            [ENGLISH]: "If you are unable to find a specific wazaren or if the information is outdated, please don't hesitate to send us your request.",
            [JAPANESE]: "特定のサビ技が見つからない場合や情報が古い場合は、お気軽にお問い合わせください。",
            [TRADITIONAL_CHINESE]: "如果您無法找到特定的副歌技或資訊已過時，請隨時向我們發送您的請求。",
            [SIMPLIFIED_CHINESE]: "如果您无法找到特定的副歌技或资讯已过時，请随时向我们发送您的请求。",
        },
        WOTAGEISHI_MSG: {
            [ENGLISH]: "If you are unable to find a specific wazaren or if the information is outdated, please don't hesitate to send us your request.",
            [JAPANESE]: "特定のヲタ芸師が見つからない場合や情報が古い場合は、お気軽にリクエストをお送りください。",
            [TRADITIONAL_CHINESE]: "如果您無法找到特定的御宅藝師或資訊已過時，請隨時向我們發送您的請求。",
            [SIMPLIFIED_CHINESE]: "如果您无法找到特定的御宅艺师或资讯已过時，请随时向我们发送您的请求。",
        },
        ORGANIZATION_MSG: {
            [ENGLISH]: "If you are unable to find a specific organization or if the information is outdated, please don't hesitate to send us your request.",
            [JAPANESE]: "特定の団体が見つからない場合や情報が古い場合は、お気軽にリクエストをお送りください。",
            [TRADITIONAL_CHINESE]: "如果您無法找到特定的組織或資訊已過時，請隨時向我們發送您的請求。",
            [SIMPLIFIED_CHINESE]: "如果您无法找到特定的组织或资讯已过時，请随时向我们发送您的请求。",
        },
        NEW_WAZAREN: {
            [ENGLISH]: "New Wazaren",
            [JAPANESE]: "新しいサビ技",
            [TRADITIONAL_CHINESE]: "新副歌技",
            [SIMPLIFIED_CHINESE]: "新副歌技",
        },
        UPDATE_WAZAREN: {
            [ENGLISH]: "Update Wazaren",
            [JAPANESE]: "サビ技の更新",
            [TRADITIONAL_CHINESE]: "更新副歌技",
            [SIMPLIFIED_CHINESE]: "更新副歌技",
        },
        NEW_WOTAGEISHI: {
            [ENGLISH]: "New Wotageishi",
            [JAPANESE]: "新しいヲタ芸師",
            [TRADITIONAL_CHINESE]: "新御宅藝師",
            [SIMPLIFIED_CHINESE]: "新御宅艺师",
        },
        UPDATE_WOTAGEISHI: {
            [ENGLISH]: "Update Wotageishi",
            [JAPANESE]: "ヲタ芸師の更新",
            [TRADITIONAL_CHINESE]: "更新御宅藝師",
            [SIMPLIFIED_CHINESE]: "更新御宅艺师",
        },
        NEW_ORGANIZATION: {
            [ENGLISH]: "New Organization",
            [JAPANESE]: "新しい団体",
            [TRADITIONAL_CHINESE]: "新組織",
            [SIMPLIFIED_CHINESE]: "新组织",
        },
        UPDATE_ORGANIZATION: {
            [ENGLISH]: "Update Organization",
            [JAPANESE]: "団体の更新",
            [TRADITIONAL_CHINESE]: "更新組織",
            [SIMPLIFIED_CHINESE]: "更新组织",
        },
    },
    DIALOG: {
        TITLE: {
            [ENGLISH]: "Login Required",
            [JAPANESE]: "ログインが必要です",
            [TRADITIONAL_CHINESE]: "需要登入",
            [SIMPLIFIED_CHINESE]: "需要登入",
        },
        CONTENT: {
            [ENGLISH]: "Please login before requesting any topic.",
            [JAPANESE]: "トピックをリクエストする前にログインしてください。",
            [TRADITIONAL_CHINESE]: "請在請求任何主題之前登入。",
            [SIMPLIFIED_CHINESE]: "请在请求任何主题之前登入。",
        }
    },
    STEPS: {
        FILL_IN: {
            [ENGLISH]: "Fill-in",
            [JAPANESE]: "埋める",
            [TRADITIONAL_CHINESE]: "填寫",
            [SIMPLIFIED_CHINESE]: "填写",
        },
        REVIEW: {
            [ENGLISH]: "Review",
            [JAPANESE]: "レビュー",
            [TRADITIONAL_CHINESE]: "審查",
            [SIMPLIFIED_CHINESE]: "审查",
        },
        CONFIRMATION: {
            [ENGLISH]: "Confirmation",
            [JAPANESE]: "確認",
            [TRADITIONAL_CHINESE]: "確認",
            [SIMPLIFIED_CHINESE]: "确认",
        }
    },
    FIELDS: {
        NAME: {
            [ENGLISH]: "Name",
            [JAPANESE]: "名称",
            [TRADITIONAL_CHINESE]: "名字",
            [SIMPLIFIED_CHINESE]: "名字",
        },
        DEFAULT_LANG: {
            [ENGLISH]: "Default Language",
            [JAPANESE]: "デフォルト言語",
            [TRADITIONAL_CHINESE]: "預設語言",
            [SIMPLIFIED_CHINESE]: "默认语言",
        },
        LANG: {
            EN: {
                [ENGLISH]: "English",
                [JAPANESE]: "英語",
                [TRADITIONAL_CHINESE]: "英文",
                [SIMPLIFIED_CHINESE]: "英文",
            },
            JP: {
                [ENGLISH]: "Japanese",
                [JAPANESE]: "日本語",
                [TRADITIONAL_CHINESE]: "日文",
                [SIMPLIFIED_CHINESE]: "日文",
            },
            TC: {
                [ENGLISH]: "Traditional Chinese",
                [JAPANESE]: "中国語（繁体字）",
                [TRADITIONAL_CHINESE]: "繁體中文",
                [SIMPLIFIED_CHINESE]: "繁体中文",
            },
            SC: {
                [ENGLISH]: "Simplified Chinese",
                [JAPANESE]: "中国語（簡体字）",
                [TRADITIONAL_CHINESE]: "簡體中文",
                [SIMPLIFIED_CHINESE]: "简体中文",
            }
        },
        OTHER: {
            [ENGLISH]: "Other",
            [JAPANESE]: "他の",
            [TRADITIONAL_CHINESE]: "其他",
            [SIMPLIFIED_CHINESE]: "其他",
        },
        START_DATE: {
            [ENGLISH]: "Start Date",
            [JAPANESE]: "開始日",
            [TRADITIONAL_CHINESE]: "開始日期",
            [SIMPLIFIED_CHINESE]: "开始日期",
        },
        WAZAREN_UID: {
            [ENGLISH]: "Wazaren UID",
            [JAPANESE]: "サビ技 UID",
            [TRADITIONAL_CHINESE]: "副歌技 UID",
            [SIMPLIFIED_CHINESE]: "副歌技 UID",
        },
        WOTAGEISHI_UID: {
            [ENGLISH]: "Wotageishi UID",
            [JAPANESE]: "ヲタ芸師 UID",
            [TRADITIONAL_CHINESE]: "御宅藝師 UID",
            [SIMPLIFIED_CHINESE]: "御宅艺师 UID",
        },
        ORGANIZATION_UID: {
            [ENGLISH]: "Organization UID",
            [JAPANESE]: "団体 UID",
            [TRADITIONAL_CHINESE]: "組織 UID",
            [SIMPLIFIED_CHINESE]: "组织 UID",
        },
        YEAR: {
            [ENGLISH]: "Year",
            [JAPANESE]: "年",
            [TRADITIONAL_CHINESE]: "年",
            [SIMPLIFIED_CHINESE]: "年",
        },
        MONTH: {
            [ENGLISH]: "Month",
            [JAPANESE]: "月",
            [TRADITIONAL_CHINESE]: "月",
            [SIMPLIFIED_CHINESE]: "月",
        },
        DAY: {
            [ENGLISH]: "Day",
            [JAPANESE]: "日",
            [TRADITIONAL_CHINESE]: "日",
            [SIMPLIFIED_CHINESE]: "日",
        }
    },
    PLACEHOLDERS: {
        ENTER: {
            NAME: {
                EN: {
                    [ENGLISH]: "Enter English Name...",
                    [JAPANESE]: "英語の名前を入力してください...",
                    [TRADITIONAL_CHINESE]: "輸入英文名稱...",
                    [SIMPLIFIED_CHINESE]: "输入英文名称...",
                },
                JP: {
                    [ENGLISH]: "Enter Japanese Name...",
                    [JAPANESE]: "日本語の名前を入力してください...",
                    [TRADITIONAL_CHINESE]: "輸入日文名稱...",
                    [SIMPLIFIED_CHINESE]: "输入日语名称...",
                },
                TC: {
                    [ENGLISH]: "Enter Traditional Chinese Name...",
                    [JAPANESE]: "繁体字中国語名を入力してください...",
                    [TRADITIONAL_CHINESE]: "輸入繁體中文名稱...",
                    [SIMPLIFIED_CHINESE]: "输入繁体中文姓名...",
                },
                SC: {
                    [ENGLISH]: "Enter Simplified Chinese Name...",
                    [JAPANESE]: "簡体字中国語名を入力してください...",
                    [TRADITIONAL_CHINESE]: "輸入簡體中文名稱...",
                    [SIMPLIFIED_CHINESE]: "输入简体中文名称...",
                }
            },
            DESCRIPTION: {
                EN: {
                    [ENGLISH]: "Enter English Description...",
                    [JAPANESE]: "英語の説明を入力してください...",
                    [TRADITIONAL_CHINESE]: "輸入英文說明...",
                    [SIMPLIFIED_CHINESE]: "输入英文说明...",
                },
                JP: {
                    [ENGLISH]: "Enter English Description...",
                    [JAPANESE]: "日本語の説明を入力してください...",
                    [TRADITIONAL_CHINESE]: "輸入日文說明...",
                    [SIMPLIFIED_CHINESE]: "输入日语说明...",
                },
                TC: {
                    [ENGLISH]: "Enter Traditional Description...",
                    [JAPANESE]: "繁体字中国語の説明を入力してください...",
                    [TRADITIONAL_CHINESE]: "輸入繁體中文說明...",
                    [SIMPLIFIED_CHINESE]: "输入繁体中文说明...",
                },
                SC: {
                    [ENGLISH]: "Enter Simplified Description...",
                    [JAPANESE]: "簡体字中国語の説明を入力してください...",
                    [TRADITIONAL_CHINESE]: "輸入簡體中文說明...",
                    [SIMPLIFIED_CHINESE]: "输入简体中文说明...",
                }
            },
            VIDEO_LINK: {
                YOUTUBE: {
                    [ENGLISH]: "Enter YouTube Link...",
                    [JAPANESE]: "YouTubeリンクを入力...",
                    [TRADITIONAL_CHINESE]: "輸入 YouTube 連結...",
                    [SIMPLIFIED_CHINESE]: "输入 YouTube 链接...",
                },
                BILIBILI: {
                    [ENGLISH]: "Enter BiliBili Link...",
                    [JAPANESE]: "BiliBiliリンクを入力...",
                    [TRADITIONAL_CHINESE]: "輸入 BiliBili 連結...",
                    [SIMPLIFIED_CHINESE]: "输入 BiliBili 链接...",
                },
                X: {
                    [ENGLISH]: "Enter X Link...",
                    [JAPANESE]: "Xリンクを入力...",
                    [TRADITIONAL_CHINESE]: "輸入 X 連結...",
                    [SIMPLIFIED_CHINESE]: "输入 X 链接...",
                }
            },
            VIDEO_REMARK: {
                YOUTUBE: {
                    [ENGLISH]: "Enter YouTube Remark...",
                    [JAPANESE]: "YouTubeコメントを入力...",
                    [TRADITIONAL_CHINESE]: "輸入 YouTube 備註...",
                    [SIMPLIFIED_CHINESE]: "输入 YouTube 备注...",
                },
                BILIBILI: {
                    [ENGLISH]: "Enter BiliBili Remark...",
                    [JAPANESE]: "BiliBiliコメントを入力...",
                    [TRADITIONAL_CHINESE]: "輸入 BiliBili 備註...",
                    [SIMPLIFIED_CHINESE]: "输入 BiliBili 备注...",
                },
                X: {
                    [ENGLISH]: "Enter X Remark...",
                    [JAPANESE]: "Xコメントを入力...",
                    [TRADITIONAL_CHINESE]: "輸入 X 備註...",
                    [SIMPLIFIED_CHINESE]: "输入 X 备注...",
                }
            },
            MARKINGS: {
                [ENGLISH]: "Enter Markings...",
                [JAPANESE]: "マーキングを入力してください...",
                [TRADITIONAL_CHINESE]: "輸入標記...",
                [SIMPLIFIED_CHINESE]: "输入标记...",
            }
        },
        SEARCH: {
            CREATOR: {
                [ENGLISH]: "Search Creator...",
                [JAPANESE]: "作成者を検索...",
                [TRADITIONAL_CHINESE]: "搜尋作者...",
                [SIMPLIFIED_CHINESE]: "搜索作者...",
            },
            EDITOR: {
                [ENGLISH]: "Search Editor...",
                [JAPANESE]: "编集者を検索...",
                [TRADITIONAL_CHINESE]: "搜尋編輯者...",
                [SIMPLIFIED_CHINESE]: "搜索编辑者...",
            },
        },
    },
    ERROR_MESSAGE: {
        NON_EMPTY_DEFAULT_NAME: {
            [ENGLISH]: "Default name should not be empty.",
            [JAPANESE]: "デフォルト名は空にできません。",
            [TRADITIONAL_CHINESE]: "預設名稱不應為空。",
            [SIMPLIFIED_CHINESE]: "默认名称不能为空。",
        },
        REQUIRED_NAME: {
            EN: {
                [ENGLISH]: "At least one name is required (e.g. English).",
                [JAPANESE]: "少なくとも1つの名前が必要です（例：英語）。",
                [TRADITIONAL_CHINESE]: "至少需要一個名字（例如：英文）。",
                [SIMPLIFIED_CHINESE]: "至少需要一个名字（例如：英文）。",
            },
            JP: {
                [ENGLISH]: "At least one name is required (e.g. Japanese).",
                [JAPANESE]: "少なくとも1つの名前が必要です（例：日本語）。",
                [TRADITIONAL_CHINESE]: "至少需要一個名字（例如：日文）。",
                [SIMPLIFIED_CHINESE]: "至少需要一个名字（例如：日文）。",
            },
            TC: {
                [ENGLISH]: "At least one name is required (e.g. Traditional Chinese).",
                [JAPANESE]: "少なくとも1つの名前が必要です（例：中国語（繁体字））。",
                [TRADITIONAL_CHINESE]: "至少需要一個名字（例如：繁體中文）。",
                [SIMPLIFIED_CHINESE]: "至少需要一个名字（例如：繁体中文）。",
            },
            SC: {
                [ENGLISH]: "At least one name is required (e.g. Simplified Chinese).",
                [JAPANESE]: "少なくとも1つの名前が必要です（例：中国語（簡体字））。",
                [TRADITIONAL_CHINESE]: "至少需要一個名字（例如：簡體中文）。",
                [SIMPLIFIED_CHINESE]: "至少需要一个名字（例如：简体中文）。",
            },
        }
    },
    CONFIRMATION_MESSAGE: {
        UPLOADING: {
            [ENGLISH]: "Uploading...",
            [JAPANESE]: "アップロード中...",
            [TRADITIONAL_CHINESE]: "正在上傳...",
            [SIMPLIFIED_CHINESE]: "正在上传...",
        },
        UPLOAD_SUCCESSFUL: {
            [ENGLISH]: "Upload Successful.",
            [JAPANESE]: "アップロードに成功しました。",
            [TRADITIONAL_CHINESE]: "上傳成功...",
            [SIMPLIFIED_CHINESE]: "上传成功...",
        },
        UPLOAD_FAILED: {
            [ENGLISH]: "Upload Failed.",
            [JAPANESE]: "アップロードに失敗しました。",
            [TRADITIONAL_CHINESE]: "上傳失敗。",
            [SIMPLIFIED_CHINESE]: "上传失败。",
        }
    },
    BUTTONS: {
        BACK: {
            [ENGLISH]: "Back",
            [JAPANESE]: "戻る",
            [TRADITIONAL_CHINESE]: "返回",
            [SIMPLIFIED_CHINESE]: "返回",
        },
        NEXT: {
            [ENGLISH]: "Next",
            [JAPANESE]: "次へ",
            [TRADITIONAL_CHINESE]: "下一步",
            [SIMPLIFIED_CHINESE]: "下一步",
        },
        END: {
            [ENGLISH]: "End",
            [JAPANESE]: "終了",
            [TRADITIONAL_CHINESE]: "結束",
            [SIMPLIFIED_CHINESE]: "结束",
        },
        LOAD_WAZAREN_DATA: {
            [ENGLISH]: "Load Wazaren Data",
            [JAPANESE]: "サビ技データを読み込む",
            [TRADITIONAL_CHINESE]: "載入副歌技數據",
            [SIMPLIFIED_CHINESE]: "加载副歌技数据",
        },
        LOAD_WOTAGEISHI_DATA: {
            [ENGLISH]: "Load Wotageishi Data",
            [JAPANESE]: "ヲタ芸師データを読み込む",
            [TRADITIONAL_CHINESE]: "載入御宅藝師數據",
            [SIMPLIFIED_CHINESE]: "加载御宅艺师数据",
        },
        LOAD_ORGANIZATION_DATA: {
            [ENGLISH]: "Load Organization Data",
            [JAPANESE]: "団体データを読み込む",
            [TRADITIONAL_CHINESE]: "載入組織數據",
            [SIMPLIFIED_CHINESE]: "加载组织数据",
        }
    }
}

export const VERIFY_EMAIL = {
    MESSAGE: {
        VERIFYING: {
            [ENGLISH]: "Verifying...",
            [JAPANESE]: "検証中...",
            [TRADITIONAL_CHINESE]: "正在驗證...",
            [SIMPLIFIED_CHINESE]: "正在验证...",
        },
        VERIFY_SUCCESSFUL: {
            [ENGLISH]: "Verify Successful.",
            [JAPANESE]: "検証成功。",
            [TRADITIONAL_CHINESE]: "驗證成功...",
            [SIMPLIFIED_CHINESE]: "验证成功...",
        },
        VERIFY_FAILED: {
            [ENGLISH]: "Verify Failed.",
            [JAPANESE]: "検証に失敗しました。",
            [TRADITIONAL_CHINESE]: "驗證失敗。",
            [SIMPLIFIED_CHINESE]: "验证失败。",
        }
    },
}

export const RESET_PASSWORD = {
    MESSAGE: {
        RESET_SUCCESSFUL: {
            [ENGLISH]: "Reset Successful.",
            [JAPANESE]: "リセットに成功しました。",
            [TRADITIONAL_CHINESE]: "重置成功...",
            [SIMPLIFIED_CHINESE]: "重置成功...",
        },
        PASSWORD_RESET_SUCCESSFUL: {
            [ENGLISH]: "Your password has been reset successfully.",
            [JAPANESE]: "パスワードが正常にリセットされました。",
            [TRADITIONAL_CHINESE]: "您的密碼已成功重設。",
            [SIMPLIFIED_CHINESE]: "您的密码已成功重置。",
        },
        RESET_FAILED: {
            [ENGLISH]: "Reset Failed.",
            [JAPANESE]: "リセットに失敗しました。",
            [TRADITIONAL_CHINESE]: "重置失敗。",
            [SIMPLIFIED_CHINESE]: "重置失败。",
        },
        SOMETHING_WENT_WRONG: {
            [ENGLISH]: "Something went wrong. Please try again later.",
            [JAPANESE]: "エラーが発生しました。しばらくしてからもう一度お試しください。",
            [TRADITIONAL_CHINESE]: "出了點問題。請稍後重試。",
            [SIMPLIFIED_CHINESE]: "出了点问题。请稍后重试。",
        }
    }
}

// Approve Topic
export const APPROVE_TOPIC = {
    DASHBOARD: {
        [ENGLISH]: "Dashboard",
        [JAPANESE]: "ダッシュボード",
        [TRADITIONAL_CHINESE]: "儀表板",
        [SIMPLIFIED_CHINESE]: "仪表板",
    },
    DASHBOARD_STATUS: {
        PENDING: {
            [ENGLISH]: "Pending",
            [JAPANESE]: "保留中",
            [TRADITIONAL_CHINESE]: "待處理",
            [SIMPLIFIED_CHINESE]: "待处理",
        },
        APPROVED: {
            [ENGLISH]: "Approved",
            [JAPANESE]: "承認された",
            [TRADITIONAL_CHINESE]: "已批准",
            [SIMPLIFIED_CHINESE]: "已批准",
        },
        REJECTED: {
            [ENGLISH]: "Rejected",
            [JAPANESE]: "拒否されました",
            [TRADITIONAL_CHINESE]: "已拒絕",
            [SIMPLIFIED_CHINESE]: "已拒绝",
        },
        TOTAL: {
            [ENGLISH]: "Rejected",
            [JAPANESE]: "合計",
            [TRADITIONAL_CHINESE]: "合計",
            [SIMPLIFIED_CHINESE]: "合计",
        }
    },
    COMMON: {
        TABLE_HEADERS: {
            REQUEST_TYPE: {
                [ENGLISH]: "Request Type",
                [JAPANESE]: "要求タイプ",
                [TRADITIONAL_CHINESE]: "請求類型",
                [SIMPLIFIED_CHINESE]: "请求类型",
            },
            NAME: {
                [ENGLISH]: "Name",
                [JAPANESE]: "名称",
                [TRADITIONAL_CHINESE]: "名稱",
                [SIMPLIFIED_CHINESE]: "名称",
            },
            UID: {
                [ENGLISH]: "UID",
                [JAPANESE]: "UID",
                [TRADITIONAL_CHINESE]: "UID",
                [SIMPLIFIED_CHINESE]: "UID",
            },
            STATUS: {
                [ENGLISH]: "Status",
                [JAPANESE]: "状態",
                [TRADITIONAL_CHINESE]: "狀態",
                [SIMPLIFIED_CHINESE]: "状态",
            },
            OTHERS: {
                [ENGLISH]: "Others",
                [JAPANESE]: "その他",
                [TRADITIONAL_CHINESE]: "其他",
                [SIMPLIFIED_CHINESE]: "其他",
            },
        },
        FIELDS: {
            METADATA: {
                [ENGLISH]: "Metadata",
                [JAPANESE]: "メタデータ",
                [TRADITIONAL_CHINESE]: "元資料",
                [SIMPLIFIED_CHINESE]: "元资料",
            },
        },
        BUTTONS: {
            PREVIEW: {
                [ENGLISH]: "Preview",
                [JAPANESE]: "プレビュー",
                [TRADITIONAL_CHINESE]: "預覽",
                [SIMPLIFIED_CHINESE]: "预览",
            },
            RETURN: {
                [ENGLISH]: "Return",
                [JAPANESE]: "戻る",
                [TRADITIONAL_CHINESE]: "返回",
                [SIMPLIFIED_CHINESE]: "返回",
            },
            SAVE: {
                [ENGLISH]: "Save",
                [JAPANESE]: "保存",
                [TRADITIONAL_CHINESE]: "保存",
                [SIMPLIFIED_CHINESE]: "保存",
            },
            APPROVE: {
                [ENGLISH]: "Approve",
                [JAPANESE]: "承認する",
                [TRADITIONAL_CHINESE]: "批准",
                [SIMPLIFIED_CHINESE]: "批准",
            },
            REJECT: {
                [ENGLISH]: "Reject",
                [JAPANESE]: "拒否する",
                [TRADITIONAL_CHINESE]: "拒絕",
                [SIMPLIFIED_CHINESE]: "拒绝",
            }
        },
        ITEM: {
            NEW: {
                [ENGLISH]: "New",
                [JAPANESE]: "新",
                [TRADITIONAL_CHINESE]: "新",
                [SIMPLIFIED_CHINESE]: "新",
            },
            UPDATE: {
                [ENGLISH]: "Update",
                [JAPANESE]: "更新",
                [TRADITIONAL_CHINESE]: "更新",
                [SIMPLIFIED_CHINESE]: "更新",
            },
            AVAILABLE: {
                [ENGLISH]: "Available",
                [JAPANESE]: "可用",
                [TRADITIONAL_CHINESE]: "可用",
                [SIMPLIFIED_CHINESE]: "可用",
            },
            REVIEWING: {
                [ENGLISH]: "Reviewing",
                [JAPANESE]: "レビュー",
                [TRADITIONAL_CHINESE]: "審查中",
                [SIMPLIFIED_CHINESE]: "审查中",
            }
        }
    }
}

// Login Form
export const LOGIN_FORM = {
    ERROR_MESSAGE: {
        INCORRECT_EMAIL_OR_PASSWORD: {
            [ENGLISH]: 'Incorrect email address or password.',
            [JAPANESE]: "メールアドレスまたはパスワードが間違っています。",
            [TRADITIONAL_CHINESE]: "電子郵件地址或密碼不正確。",
            [SIMPLIFIED_CHINESE]: "电子邮件地址或密码不正确。",
        },
        ENTER_VALID_EMAIL: {
            [ENGLISH]: 'Please enter a valid email address.',
            [JAPANESE]: "有効なメールアドレスを入力してください。",
            [TRADITIONAL_CHINESE]: "請輸入有效的電子郵件地址。",
            [SIMPLIFIED_CHINESE]: "请输入有效的电子邮件地址。",
        },
        PASSWORD_STRENGTH: {
            [ENGLISH]: 'Password must be at least 8 characters long with either three of below combinations: number, uppercase letter, lowercase letter & special character',
            [JAPANESE]: "パスワードは、数字、大文字、小文字、特殊文字のいずれか3つを含む8文字以上でなければなりません。",
            [TRADITIONAL_CHINESE]: "密碼長度必須至少為 8 個字符，且包含以下三種組合：數字、大寫字母、小寫字母和特殊字符。",
            [SIMPLIFIED_CHINESE]: "密码长度必须至少为 8 个字符，且包含以下三种组合：数字、大写字母、小写字母和特殊字符。",
        }
    },
    EMAIL: {
        [ENGLISH]: 'Email Address',
        [JAPANESE]: "電子メールアドレス",
        [TRADITIONAL_CHINESE]: "電郵地址",
        [SIMPLIFIED_CHINESE]: "电邮地址",
    },
    PASSWORD: {
        [ENGLISH]: 'Password',
        [JAPANESE]: "パスワード",
        [TRADITIONAL_CHINESE]: "密碼",
        [SIMPLIFIED_CHINESE]: "密码",
    },
    FORGOT_YOUR_PASSWORD: {
        [ENGLISH]: 'Forgot your password?',
        [JAPANESE]: "パスワードをお忘れですか？",
        [TRADITIONAL_CHINESE]: "忘記密碼了嗎？",
        [SIMPLIFIED_CHINESE]: "忘记密码了吗？",
    },
    REMEMBER_ME: {
        [ENGLISH]: "Remember me",
        [JAPANESE]: "私を覚えてますか?",
        [TRADITIONAL_CHINESE]: "記住帳號",
        [SIMPLIFIED_CHINESE]: "记住账号",
    },
    DONT_HAVE_ACCOUNT: {
        [ENGLISH]: "Don't have an account?",
        [JAPANESE]: "アカウントをお持ちではありませんか?",
        [TRADITIONAL_CHINESE]: "沒有帳戶？",
        [SIMPLIFIED_CHINESE]: "沒有帳戶？",
    },
    WELCOME_BACK: {
        [ENGLISH]: "Welcome back! Please sign in to your account",
        [JAPANESE]: "おかえりなさい！アカウントにサインインしてください",
        [TRADITIONAL_CHINESE]: "歡迎回來！請登入您的帳戶",
        [SIMPLIFIED_CHINESE]: "欢迎回来！请登录您的账户",
    },
    OR: {
        [ENGLISH]: "or",
        [JAPANESE]: "または",
        [TRADITIONAL_CHINESE]: "或",
        [SIMPLIFIED_CHINESE]: "或",
    },
    PLACEHOLDER: {
        ENTER_EMAIL: {
            [ENGLISH]: "Enter your email",
            [JAPANESE]: "メールアドレスを入力してください",
            [TRADITIONAL_CHINESE]: "輸入您的電子郵件",
            [SIMPLIFIED_CHINESE]: "输入您的电子邮件",
        },
        ENTER_PASSWORD: {
            [ENGLISH]: "Enter your password",
            [JAPANESE]: "パスワードを入力してください",
            [TRADITIONAL_CHINESE]: "輸入您的密碼",
            [SIMPLIFIED_CHINESE]: "输入您的密码",
        },
        ENTER_USERNAME: {
            [ENGLISH]: "Enter your username",
            [JAPANESE]: "ユーザー名を入力してください",
            [TRADITIONAL_CHINESE]: "輸入您的使用者名稱",
            [SIMPLIFIED_CHINESE]: "输入您的用户名",
        },
        CREATE_PASSWORD: {
            [ENGLISH]: "Create a strong password",
            [JAPANESE]: "強力なパスワードを作成してください",
            [TRADITIONAL_CHINESE]: "創建強密碼",
            [SIMPLIFIED_CHINESE]: "创建强密码",
        },
        ENTER_EMAIL_ADDRESS: {
            [ENGLISH]: "Enter your email address",
            [JAPANESE]: "メールアドレスを入力してください",
            [TRADITIONAL_CHINESE]: "輸入您的電子郵件地址",
            [SIMPLIFIED_CHINESE]: "输入您的电子邮件地址",
        }
    }
}

// Sign Up Form
export const SIGN_UP_FORM = {
    ERROR_MESSAGE: {
        FAILED_TO_REGISTER_ACCOUNT: {
            [ENGLISH]: "Failed to register account.",
            [JAPANESE]: "アカウントの登録に失敗しました。",
            [TRADITIONAL_CHINESE]: "註冊帳戶失敗。",
            [SIMPLIFIED_CHINESE]: "账户注册失败。",
        },
        USERNAME_LENGTH: {
            [ENGLISH]: "Username must be at least 2 characters long.",
            [JAPANESE]: "ユーザー名は 2 文字以上である必要があります。",
            [TRADITIONAL_CHINESE]: "使用者名稱長度必須至少為 2 個字元。",
            [SIMPLIFIED_CHINESE]: "用户名必须至少包含 2 个字符。",
        },
        REGISTERED_EMAIL: {
            [ENGLISH]: "Email is registered.",
            [JAPANESE]: "メールアドレスが登録されました。",
            [TRADITIONAL_CHINESE]: "電子郵件已註冊。",
            [SIMPLIFIED_CHINESE]: "电子邮件已注册。",
        },
        REGISTERED_USERNAME: {
            [ENGLISH]: "Username is registered.",
            [JAPANESE]: "ユーザー名が登録されました。",
            [TRADITIONAL_CHINESE]: "用戶名已註冊。",
            [SIMPLIFIED_CHINESE]: "用户名已注册。",
        },
    },
    USERNAME: {
        [ENGLISH]: "Username",
        [JAPANESE]: "ユーザー名",
        [TRADITIONAL_CHINESE]: "使用者名稱",
        [SIMPLIFIED_CHINESE]: "用户名",
    },
    ALREADY_HAVE_ACCOUNT: {
        [ENGLISH]: "Already have an account?",
        [JAPANESE]: "すでにアカウントをお持ちですか?",
        [TRADITIONAL_CHINESE]: "已經有帳戶？",
        [SIMPLIFIED_CHINESE]: "已有账户？",
    },
    CREATE_ACCOUNT: {
        [ENGLISH]: "Create your account to get started",
        [JAPANESE]: "アカウントを作成して始めましょう",
        [TRADITIONAL_CHINESE]: "創建您的帳戶開始使用",
        [SIMPLIFIED_CHINESE]: "创建您的账户开始使用",
    },
    PASSWORD_STRENGTH: {
        TOO_WEAK: {
            [ENGLISH]: "Too Weak",
            [JAPANESE]: "非常に弱い",
            [TRADITIONAL_CHINESE]: "非常弱",
            [SIMPLIFIED_CHINESE]: "非常弱",
        },
        WEAK: {
            [ENGLISH]: "Weak",
            [JAPANESE]: "弱い",
            [TRADITIONAL_CHINESE]: "弱",
            [SIMPLIFIED_CHINESE]: "弱",
        },
        OKAY: {
            [ENGLISH]: "Okay",
            [JAPANESE]: "良い",
            [TRADITIONAL_CHINESE]: "可以",
            [SIMPLIFIED_CHINESE]: "可以",
        },
        STRONG: {
            [ENGLISH]: "Strong",
            [JAPANESE]: "強い",
            [TRADITIONAL_CHINESE]: "强",
            [SIMPLIFIED_CHINESE]: "强",
        }
    }
}

// Reset Password
export const RESET_PASSWORD_FORM = {
    FORGOT_PASSWORD: {
        [ENGLISH]: "Forgot Password",
        [JAPANESE]: "パスワードをお忘れですか",
        [TRADITIONAL_CHINESE]: "忘記密碼",
        [SIMPLIFIED_CHINESE]: "忘记密码",
    },
    SEND_EMAIL: {
        [ENGLISH]: "Send Email",
        [JAPANESE]: "メールを送信",
        [TRADITIONAL_CHINESE]: "傳送電郵",
        [SIMPLIFIED_CHINESE]: "发送电邮",
    },
    BACK_TO_LOGIN: {
        [ENGLISH]: "Back to Login",
        [JAPANESE]: "ログインに戻る",
        [TRADITIONAL_CHINESE]: "返回登入",
        [SIMPLIFIED_CHINESE]: "返回登入",
    },
    ENTER_EMAIL_INSTRUCTIONS: {
        [ENGLISH]: "Enter your email to receive reset instructions",
        [JAPANESE]: "リセット手順を受け取るためにメールアドレスを入力してください",
        [TRADITIONAL_CHINESE]: "輸入您的電子郵件以接收重設指示",
        [SIMPLIFIED_CHINESE]: "输入您的电子邮件以接收重置指示",
    },
    RESET_PASSWORD: {
        [ENGLISH]: "Reset Password",
        [JAPANESE]: "パスワードをリセット",
        [TRADITIONAL_CHINESE]: "重設密碼",
        [SIMPLIFIED_CHINESE]: "重设密码",
    }
}


// Country
export const COUNTRY_LIST = [
    { "code": "AD", "label": { "en": "Andorra", "jp": "アンドラ", "sc": "安道尔", "tc": "安道爾" }},
    { "code": "AE", "label": { "en": "United Arab Emirates", "jp": "アラブ首長国連邦", "sc": "阿拉伯联合酋长国", "tc": "阿拉伯聯合酋長國" }},
    { "code": "AF", "label": { "en": "Afghanistan", "jp": "アフガニスタン", "sc": "阿富汗", "tc": "阿富汗" }},
    { "code": "AG", "label": { "en": "Antigua and Barbuda", "jp": "アンティグア・バーブーダ", "sc": "安提瓜和巴布达", "tc": "安提瓜和巴布達" }},
    { "code": "AI", "label": { "en": "Anguilla", "jp": "アンギラ", "sc": "安圭拉", "tc": "安圭拉" }},
    { "code": "AL", "label": { "en": "Albania", "jp": "アルバニア", "sc": "阿尔巴尼亚", "tc": "阿爾巴尼亞" }},
    { "code": "AM", "label": { "en": "Armenia", "jp": "アルメニア", "sc": "亚美尼亚", "tc": "亞美尼亞" }},
    { "code": "AO", "label": { "en": "Angola", "jp": "アンゴラ", "sc": "安哥拉", "tc": "安哥拉" }},
    { "code": "AQ", "label": { "en": "Antarctica", "jp": "南極大陸", "sc": "南极洲", "tc": "南極洲" }},
    { "code": "AR", "label": { "en": "Argentina", "jp": "アルゼンチン", "sc": "阿根廷", "tc": "阿根廷" }},
    { "code": "AS", "label": { "en": "American Samoa", "jp": "アメリカ領サモア", "sc": "美属萨摩亚", "tc": "美屬薩摩亞" }},
    { "code": "AT", "label": { "en": "Austria", "jp": "オーストリア", "sc": "奥地利", "tc": "奧地利" }},
    { "code": "AU", "label": { "en": "Australia", "jp": "オーストラリア", "sc": "澳大利亚", "tc": "澳大利亞"}, "suggested": true },
    { "code": "AW", "label": { "en": "Aruba", "jp": "アルバ", "sc": "阿鲁巴", "tc": "阿魯巴" }},
    { "code": "AX", "label": { "en": "Alland Islands", "jp": "オーランド諸島", "sc": "奥兰群岛", "tc": "奧蘭群島" }},
    { "code": "AZ", "label": { "en": "Azerbaijan", "jp": "アゼルバイジャン", "sc": "阿塞拜疆", "tc": "阿塞拜疆" }},
    { "code": "BA", "label": { "en": "Bosnia and Herzegovina", "jp": "ボスニア・ヘルツェゴビナ", "sc": "波斯尼亚和黑塞哥维那", "tc": "波士尼亞和黑塞哥維那" }},
    { "code": "BB", "label": { "en": "Barbados", "jp": "バルバドス", "sc": "巴巴多斯", "tc": "巴巴多斯" }},
    { "code": "BD", "label": { "en": "Bangladesh", "jp": "バングラデシュ", "sc": "孟加拉国", "tc": "孟加拉國" }},
    { "code": "BE", "label": { "en": "Belgium", "jp": "ベルギー", "sc": "比利时", "tc": "比利時" }},
    { "code": "BF", "label": { "en": "Burkina Faso", "jp": "ブルキナファソ", "sc": "布基纳法索", "tc": "布基納法索" }},
    { "code": "BG", "label": { "en": "Bulgaria", "jp": "ブルガリア", "sc": "保加利亚", "tc": "保加利亞" }},
    { "code": "BH", "label": { "en": "Bahrain", "jp": "バーレーン", "sc": "巴林", "tc": "巴林" }},
    { "code": "BI", "label": { "en": "Burundi", "jp": "ブルンジ", "sc": "布隆迪", "tc": "布隆迪" }},
    { "code": "BJ", "label": { "en": "Benin", "jp": "ベナン", "sc": "贝南", "tc": "貝南" }},
    { "code": "BL", "label": { "en": "Saint Barthelemy", "jp": "サン・バルテルミー", "sc": "圣巴泰勒米", "tc": "聖巴爾特萊米" }},
    { "code": "BM", "label": { "en": "Bermuda", "jp": "バミューダ", "sc": "百慕大", "tc": "百慕達" }},
    { "code": "BN", "label": { "en": "Brunei Darussalam", "jp": "ブルネイ・ダルサラーム", "sc": "文莱", "tc": "汶萊" }},
    { "code": "BO", "label": { "en": "Bolivia", "jp": "ボリビア", "sc": "玻利维亚", "tc": "玻利維亞" }},
    { "code": "BR", "label": { "en": "Brazil", "jp": "ブラジル", "sc": "巴西", "tc": "巴西" }},
    { "code": "BS", "label": { "en": "Bahamas", "jp": "バハマ", "sc": "巴哈马", "tc": "巴哈馬" }},
    { "code": "BT", "label": { "en": "Bhutan", "jp": "ブータン", "sc": "不丹", "tc": "不丹" }},
    { "code": "BV", "label": { "en": "Bouvet Island", "jp": "ブーベ島", "sc": "布維特岛", "tc": "布維特島" }},
    { "code": "BW", "label": { "en": "Botswana", "jp": "ボツワナ", "sc": "博茨瓦纳", "tc": "博茨瓦納" }},
    { "code": "BY", "label": { "en": "Belarus", "jp": "ベラルーシ", "sc": "白俄罗斯", "tc": "白俄羅斯" }},
    { "code": "BZ", "label": { "en": "Belize", "jp": "ベリーズ", "sc": "伯利兹", "tc": "伯利茲" }},
    { "code": "CA", "label": { "en": "Canada", "jp": "カナダ", "sc": "加拿大", "tc": "加拿大"}, "suggested": true },
    { "code": "CC", "label": { "en": "Cocos (Keeling) Islands", "jp": "ココス（キーリング）諸島", "sc": "科科斯（基林）群岛", "tc": "科科斯（基林）群島" }},
    { "code": "CD", "label": { "en": "Congo, Democratic Republic of the", "jp": "コンゴ民主共和国", "sc": "刚果民主共和国", "tc": "剛果民主共和國" }},
    { "code": "CF", "label": { "en": "Central African Republic", "jp": "中央アフリカ共和国", "sc": "中非共和国", "tc": "中非共和國" }},
    { "code": "CG", "label": { "en": "Congo, Republic of the", "jp": "コンゴ共和国", "sc": "刚果共和国", "tc": "剛果共和國" }},
    { "code": "CH", "label": { "en": "Switzerland", "jp": "スイス", "sc": "瑞士", "tc": "瑞士" }},
    { "code": "CI", "label": { "en": "Côte d'Ivoire", "jp": "コートジボワール", "sc": "科特迪瓦", "tc": "科特迪瓦" }},
    { "code": "CK", "label": { "en": "Cook Islands", "jp": "クック諸島", "sc": "库克群岛", "tc": "庫克群島" }},
    { "code": "CL", "label": { "en": "Chile", "jp": "チリ", "sc": "智利", "tc": "智利" }},
    { "code": "CM", "label": { "en": "Cameroon", "jp": "カメルーン", "sc": "喀麦隆", "tc": "喀麥隆" }},
    { "code": "CN", "label": { "en": "China", "jp": "中国", "sc": "中国", "tc": "中國"}, "suggested": true },
    { "code": "CO", "label": { "en": "Colombia", "jp": "コロンビア", "sc": "哥伦比亚", "tc": "哥倫比亞" }},
    { "code": "CR", "label": { "en": "Costa Rica", "jp": "コスタリカ", "sc": "哥斯达黎加", "tc": "哥斯達黎加" }},
    { "code": "CU", "label": { "en": "Cuba", "jp": "キューバ", "sc": "古巴", "tc": "古巴" }},
    { "code": "CV", "label": { "en": "Cabo Verde", "jp": "カーボベルデ", "sc": "佛得角", "tc": "佛得角" }},
    { "code": "CW", "label": { "en": "Curaçao", "jp": "キュラソー", "sc": "库拉索", "tc": "庫拉索" }},
    { "code": "CX", "label": { "en": "Christmas Island", "jp": "クリスマス島", "sc": "圣诞岛", "tc": "聖誕島" }},
    { "code": "CY", "label": { "en": "Cyprus", "jp": "キプロス", "sc": "塞浦路斯", "tc": "賽普勒斯" }},
    { "code": "CZ", "label": { "en": "Czech Republic", "jp": "チェコ共和国", "sc": "捷克共和国", "tc": "捷克共和國" }},
    { "code": "DE", "label": { "en": "Germany", "jp": "ドイツ", "sc": "德国", "tc": "德國" }},
    { "code": "DJ", "label": { "en": "Djibouti", "jp": "ジブチ", "sc": "吉布提", "tc": "吉布提" }},
    { "code": "DK", "label": { "en": "Denmark", "jp": "デンマーク", "sc": "丹麦", "tc": "丹麥" }},
    { "code": "DM", "label": { "en": "Dominica", "jp": "ドミニカ", "sc": "多米尼克", "tc": "多米尼克" }},
    { "code": "DO", "label": { "en": "Dominican Republic", "jp": "ドミニカ共和国", "sc": "多米尼加共和国", "tc": "多明尼加共和國" }},
    { "code": "DZ", "label": { "en": "Algeria", "jp": "アルジェリア", "sc": "阿尔及利亚", "tc": "阿爾及利亞" }},
    { "code": "EC", "label": { "en": "Ecuador", "jp": "エクアドル", "sc": "厄瓜多尔", "tc": "厄瓜多爾" }},
    { "code": "EE", "label": { "en": "Estonia", "jp": "エストニア", "sc": "爱沙尼亚", "tc": "愛沙尼亞" }},
    { "code": "EG", "label": { "en": "Egypt", "jp": "エジプト", "sc": "埃及", "tc": "埃及" }},
    { "code": "EH", "label": { "en": "Western Sahara", "jp": "西サハラ", "sc": "西撒哈拉", "tc": "西撒哈拉" }},
    { "code": "ER", "label": { "en": "Eritrea", "jp": "エリトリア", "sc": "厄立特里亚", "tc": "厄立特里亞" }},
    { "code": "ES", "label": { "en": "Spain", "jp": "スペイン", "sc": "西班牙", "tc": "西班牙" }},
    { "code": "ET", "label": { "en": "Ethiopia", "jp": "エチオピア", "sc": "埃塞俄比亚", "tc": "埃塞俄比亞" }},
    { "code": "FI", "label": { "en": "Finland", "jp": "フィンランド", "sc": "芬兰", "tc": "芬蘭" }},
    { "code": "FJ", "label": { "en": "Fiji", "jp": "フィジー", "sc": "斐济", "tc": "斐濟" }},
    { "code": "FM", "label": { "en": "Micronesia, Federated States of", "jp": "ミクロネシア連邦", "sc": "密克罗尼西亚联邦", "tc": "密克羅尼西亞聯邦" }},
    { "code": "FO", "label": { "en": "Faroe Islands", "jp": "フェロー諸島", "sc": "法罗群岛", "tc": "法羅群島" }},
    { "code": "FR", "label": { "en": "France", "jp": "フランス", "sc": "法国", "tc": "法國" }},
    { "code": "GA", "label": { "en": "Gabon", "jp": "ガボン", "sc": "加蓬", "tc": "加蓬" }},
    { "code": "GB", "label": { "en": "United Kingdom", "jp": "イギリス", "sc": "英国", "tc": "英國" }, "suggested": true },
    { "code": "GD", "label": { "en": "Grenada", "jp": "グレナダ", "sc": "格林纳达", "tc": "格林納達" }},
    { "code": "GE", "label": { "en": "Georgia", "jp": "ジョージア", "sc": "格鲁吉亚", "tc": "喬治亞" }},
    { "code": "GF", "label": { "en": "French Guiana", "jp": "フランス領ギアナ", "sc": "法属圭亚那", "tc": "法屬圭亞那" }},
    { "code": "GG", "label": { "en": "Guernsey", "jp": "ガーンジー", "sc": "根西岛", "tc": "根西島" }},
    { "code": "GH", "label": { "en": "Ghana", "jp": "ガーナ", "sc": "加纳", "tc": "加納" }},
    { "code": "GI", "label": { "en": "Gibraltar", "jp": "ジブラルタル", "sc": "直布罗陀", "tc": "直布羅陀" }},
    { "code": "GL", "label": { "en": "Greenland", "jp": "グリーンランド", "sc": "格林兰", "tc": "格林蘭" }},
    { "code": "GM", "label": { "en": "Gambia", "jp": "ガンビア", "sc": "冈比亚", "tc": "岡比亞" }},
    { "code": "GN", "label": { "en": "Guinea", "jp": "ギニア", "sc": "几内亚", "tc": "幾內亞" }},
    { "code": "GP", "label": { "en": "Guadeloupe", "jp": "グアドループ", "sc": "瓜德罗普", "tc": "瓜德羅普" }},
    { "code": "GQ", "label": { "en": "Equatorial Guinea", "jp": "赤道ギニア", "sc": "赤道几内亚", "tc": "赤道幾內亞" }},
    { "code": "GR", "label": { "en": "Greece", "jp": "ギリシャ", "sc": "希腊", "tc": "希臘" }},
    { "code": "GT", "label": { "en": "Guatemala", "jp": "グアテマラ", "sc": "危地马拉", "tc": "危地馬拉" }},
    { "code": "GU", "label": { "en": "Guam", "jp": "グアム", "sc": "关岛", "tc": "關島" }},
    { "code": "GW", "label": { "en": "Guinea-Bissau", "jp": "ギニアビサウ", "sc": "几内亚比绍", "tc": "幾內亞比紹" }},
    { "code": "GY", "label": { "en": "Guyana", "jp": "ガイアナ", "sc": "圭亚那", "tc": "圭亞那" }},
    { "code": "HK", "label": { "en": "Hong Kong", "jp": "香港", "sc": "香港", "tc": "香港" }},
    { "code": "HM", "label": { "en": "Heard Island and McDonald Islands", "jp": "ハード島とマクドナルド諸島", "sc": "赫德岛和麦克唐纳岛", "tc": "赫德島和麥克唐納島" }},
    { "code": "HN", "label": { "en": "Honduras", "jp": "ホンジュラス", "sc": "洪都拉斯", "tc": "洪都拉斯" }},
    { "code": "HR", "label": { "en": "Croatia", "jp": "クロアチア", "sc": "克罗地亚", "tc": "克羅地亞" }},
    { "code": "HT", "label": { "en": "Haiti", "jp": "ハイチ", "sc": "海地", "tc": "海地" }},
    { "code": "HU", "label": { "en": "Hungary", "jp": "ハンガリー", "sc": "匈牙利", "tc": "匈牙利" }},
    { "code": "ID", "label": { "en": "Indonesia", "jp": "インドネシア", "sc": "印尼", "tc": "印尼" }},
    { "code": "IE", "label": { "en": "Ireland", "jp": "アイルランド", "sc": "爱尔兰", "tc": "愛爾蘭" }},
    { "code": "IL", "label": { "en": "Israel", "jp": "イスラエル", "sc": "以色列", "tc": "以色列" }},
    { "code": "IM", "label": { "en": "Isle of Man", "jp": "マン島", "sc": "马恩岛", "tc": "馬恩島" }},
    { "code": "IN", "label": { "en": "India", "jp": "インド", "sc": "印度", "tc": "印度" }},
    { "code": "IO", "label": { "en": "British Indian Ocean Territory", "jp": "イギリス領インド洋地域", "sc": "英属印度洋地区", "tc": "英屬印度洋地區" }},
    { "code": "IQ", "label": { "en": "Iraq", "jp": "イラク", "sc": "伊拉克", "tc": "伊拉克" }},
    { "code": "IR", "label": { "en": "Iran", "jp": "イラン", "sc": "伊朗", "tc": "伊朗" }},
    { "code": "IS", "label": { "en": "Iceland", "jp": "アイスランド", "sc": "冰岛", "tc": "冰島" }},
    { "code": "IT", "label": { "en": "Italy", "jp": "イタリア", "sc": "意大利", "tc": "義大利" }},
    { "code": "JE", "label": { "en": "Jersey", "jp": "ジャージー", "sc": "泽西岛", "tc": "澤西島" }},
    { "code": "JM", "label": { "en": "Jamaica", "jp": "ジャマイカ", "sc": "牙买加", "tc": "牙買加" }},
    { "code": "JO", "label": { "en": "Jordan", "jp": "ヨルダン", "sc": "约旦", "tc": "約旦" }},
    { "code": "JP", "label": { "en": "Japan", "jp": "日本", "sc": "日本", "tc": "日本" }},
    { "code": "KE", "label": { "en": "Kenya", "jp": "ケニア", "sc": "肯尼亚", "tc": "肯尼亞" }},
    { "code": "KG", "label": { "en": "Kyrgyzstan", "jp": "キルギス", "sc": "吉尔吉斯斯坦", "tc": "吉爾吉斯斯坦" }},
    { "code": "KH", "label": { "en": "Cambodia", "jp": "カンボジア", "sc": "柬埔寨", "tc": "柬埔寨" }},
    { "code": "KI", "label": { "en": "Kiribati", "jp": "キリバス", "sc": "基里巴斯", "tc": "基里巴斯" }},
    { "code": "KM", "label": { "en": "Comoros", "jp": "コモロ", "sc": "科摩罗", "tc": "科摩羅" }},
    { "code": "KN", "label": { "en": "Saint Kitts and Nevis", "jp": "セントクリストファー・ネーヴィス", "sc": "圣基茨和尼维斯", "tc": "聖基茨和尼維斯" }},
    { "code": "KP", "label": { "en": "North Korea", "jp": "北朝鮮", "sc": "朝鲜", "tc": "北韓" }},
    { "code": "KR", "label": { "en": "South Korea", "jp": "韓国", "sc": "韩国", "tc": "韓國" }},
    { "code": "KW", "label": { "en": "Kuwait", "jp": "クウェート", "sc": "科威特", "tc": "科威特" }},
    { "code": "KY", "label": { "en": "Cayman Islands", "jp": "ケイマン諸島", "sc": "开曼群岛", "tc": "開曼群島" }},
    { "code": "KZ", "label": { "en": "Kazakhstan", "jp": "カザフスタン", "sc": "哈萨克斯坦", "tc": "哈薩克斯坦" }},
    { "code": "LA", "label": { "en": "Laos", "jp": "ラオス", "sc": "老挝", "tc": "老撾" }},
    { "code": "LB", "label": { "en": "Lebanon", "jp": "レバノン", "sc": "黎巴嫩", "tc": "黎巴嫩" }},
    { "code": "LC", "label": { "en": "Saint Lucia", "jp": "セントルシア", "sc": "圣露西亚", "tc": "聖露西亞" }},
    { "code": "LI", "label": { "en": "Liechtenstein", "jp": "リヒテンシュタイン", "sc": "列支敦士登", "tc": "列支敦士登" }},
    { "code": "LK", "label": { "en": "Sri Lanka", "jp": "スリランカ", "sc": "斯里兰卡", "tc": "斯里蘭卡" }},
    { "code": "LR", "label": { "en": "Liberia", "jp": "リベリア", "sc": "利比里亚", "tc": "利比里亞" }},
    { "code": "LS", "label": { "en": "Lesotho", "jp": "レソト", "sc": "莱索托", "tc": "萊索托" }},
    { "code": "LT", "label": { "en": "Lithuania", "jp": "リトアニア", "sc": "立陶宛", "tc": "立陶宛" }},
    { "code": "LU", "label": { "en": "Luxembourg", "jp": "ルクセンブルク", "sc": "卢森堡", "tc": "盧森堡" }},
    { "code": "LV", "label": { "en": "Latvia", "jp": "ラトビア", "sc": "拉脱维亚", "tc": "拉脫維亞" }},
    { "code": "LY", "label": { "en": "Libya", "jp": "リビア", "sc": "利比亚", "tc": "利比亞" }},
    { "code": "MA", "label": { "en": "Morocco", "jp": "モロッコ", "sc": "摩洛哥", "tc": "摩洛哥" }},
    { "code": "MC", "label": { "en": "Monaco", "jp": "モナコ", "sc": "摩纳哥", "tc": "摩納哥" }},
    { "code": "MD", "label": { "en": "Moldova", "jp": "モルドバ", "sc": "摩尔多瓦", "tc": "摩爾多瓦" }},
    { "code": "ME", "label": { "en": "Montenegro", "jp": "モンテネグロ", "sc": "黑山", "tc": "黑山" }},
    { "code": "MF", "label": { "en": "Saint Martin", "jp": "サン・マルタン", "sc": "圣马丁", "tc": "聖馬丁" }},
    { "code": "MG", "label": { "en": "Madagascar", "jp": "マダガスカル", "sc": "马达加斯加", "tc": "馬達加斯加" }},
    { "code": "MH", "label": { "en": "Marshall Islands", "jp": "マーシャル諸島", "sc": "马绍尔群岛", "tc": "馬紹爾群島" }},
    { "code": "MK", "label": { "en": "North Macedonia", "jp": "北マケドニア", "sc": "北马其顿", "tc": "北馬其頓" }},
    { "code": "ML", "label": { "en": "Mali", "jp": "マリ", "sc": "马里", "tc": "馬里" }},
    { "code": "MM", "label": { "en": "Myanmar", "jp": "ミャンマー", "sc": "缅甸", "tc": "緬甸" }},
    { "code": "MN", "label": { "en": "Mongolia", "jp": "モンゴル", "sc": "蒙古", "tc": "蒙古" }},
    { "code": "MO", "label": { "en": "Macao", "jp": "マカオ", "sc": "澳门", "tc": "澳門" }},
    { "code": "MP", "label": { "en": "Northern Mariana Islands", "jp": "北マリアナ諸島", "sc": "北马里亚纳群岛", "tc": "北馬利亞納群島" }},
    { "code": "MQ", "label": { "en": "Martinique", "jp": "マルティニーク", "sc": "马提尼克", "tc": "馬提尼克" }},
    { "code": "MR", "label": { "en": "Mauritania", "jp": "モーリタニア", "sc": "毛里塔尼亚", "tc": "毛里塔尼亞" }},
    { "code": "MS", "label": { "en": "Montserrat", "jp": "モントセラト", "sc": "蒙特塞拉特", "tc": "蒙特塞拉特" }},
    { "code": "MT", "label": { "en": "Malta", "jp": "マルタ", "sc": "马耳他", "tc": "馬耳他" }},
    { "code": "MU", "label": { "en": "Mauritius", "jp": "モーリシャス", "sc": "毛里求斯", "tc": "毛里求斯" }},
    { "code": "MV", "label": { "en": "Maldives", "jp": "モルディブ", "sc": "马尔代夫", "tc": "馬爾代夫" }},
    { "code": "MW", "label": { "en": "Malawi", "jp": "マラウイ", "sc": "马拉维", "tc": "馬拉維" }},
    { "code": "MX", "label": { "en": "Mexico", "jp": "メキシコ", "sc": "墨西哥", "tc": "墨西哥" }},
    { "code": "MY", "label": { "en": "Malaysia", "jp": "マレーシア", "sc": "马来西亚", "tc": "馬來西亞" }},
    { "code": "MZ", "label": { "en": "Mozambique", "jp": "モザンビーク", "sc": "莫桑比克", "tc": "莫桑比克" }},
    { "code": "NA", "label": { "en": "Namibia", "jp": "ナミビア", "sc": "纳米比亚", "tc": "納米比亞" }},
    { "code": "NC", "label": { "en": "New Caledonia", "jp": "ニューカレドニア", "sc": "新喀里多尼亚", "tc": "新喀里多尼亞" }},
    { "code": "NE", "label": { "en": "Niger", "jp": "ニジェール", "sc": "尼日尔", "tc": "尼日爾" }},
    { "code": "NF", "label": { "en": "Norfolk Island", "jp": "ノーフォーク島", "jp-1": "ノーフォーク島", "sc": "诺福克岛", "tc": "諾福克島" }},
    { "code": "NG", "label": { "en": "Nigeria", "jp": "ナイジェリア", "sc": "尼日利亚", "tc": "奈及利亞" }},
    { "code": "NI", "label": { "en": "Nicaragua", "jp": "ニカラグア", "sc": "尼加拉瓜", "tc": "尼加拉瓜" }},
    { "code": "NL", "label": { "en": "Netherlands", "jp": "オランダ", "sc": "荷兰", "tc": "荷蘭" }},
    { "code": "NO", "label": { "en": "Norway", "jp": "ノルウェー", "sc": "挪威", "tc": "挪威" }},
    { "code": "NP", "label": { "en": "Nepal", "jp": "ネパール", "sc": "尼泊尔", "tc": "尼泊爾" }},
    { "code": "NR", "label": { "en": "Nauru", "jp": "ナウル", "sc": "瑙鲁", "tc": "瑙魯" }},
    { "code": "NU", "label": { "en": "Niue", "jp": "ニウエ", "sc": "纽埃", "tc": "紐埃" }},
    { "code": "NZ", "label": { "en": "New Zealand", "jp": "ニュージーランド", "sc": "新西兰", "tc": "新西蘭" }},
    { "code": "OM", "label": { "en": "Oman", "jp": "オマーン", "sc": "阿曼", "tc": "阿曼" }},
    { "code": "PA", "label": { "en": "Panama", "jp": "パナマ", "sc": "巴拿马", "tc": "巴拿馬" }},
    { "code": "PE", "label": { "en": "Peru", "jp": "ペルー", "sc": "秘鲁", "tc": "秘魯" }},
    { "code": "PF", "label": { "en": "French Polynesia", "jp": "フランス領ポリネシア", "sc": "法属波利尼西亚", "tc": "法屬波利尼西亞" }},
    { "code": "PG", "label": { "en": "Papua New Guinea", "jp": "パプアニューギニア", "sc": "巴布亚新几内亚", "tc": "巴布亞新幾內亞" }},
    { "code": "PH", "label": { "en": "Philippines", "jp": "フィリピン", "sc": "菲律宾", "tc": "菲律賓" }},
    { "code": "PK", "label": { "en": "Pakistan", "jp": "パキスタン", "sc": "巴基斯坦", "tc": "巴基斯坦" }},
    { "code": "PL", "label": { "en": "Poland", "jp": "ポーランド", "sc": "波兰", "tc": "波蘭" }},
    { "code": "PM", "label": { "en": "Saint Pierre and Miquelon", "jp": "サン・ピエール島とミクロン島", "sc": "圣皮埃尔和密克隆", "tc": "聖皮埃爾和米克隆" }},
    { "code": "PN", "label": { "en": "Pitcairn", "jp": "ピトケアン", "sc": "皮特凯恩", "tc": "皮特凱恩" }},
    { "code": "PR", "label": { "en": "Puerto Rico", "jp": "プエルトリコ", "sc": "波多黎各", "tc": "波多黎各" }},
    { "code": "PT", "label": { "en": "Portugal", "jp": "ポルトガル", "sc": "葡萄牙", "tc": "葡萄牙" }},
    { "code": "PW", "label": { "en": "Palau", "jp": "パラオ", "sc": "帕劳", "tc": "帛琉" }},
    { "code": "PY", "label": { "en": "Paraguay", "jp": "パラグアイ", "sc": "巴拉圭", "tc": "巴拉圭" }},
    { "code": "QA", "label": { "en": "Qatar", "jp": "カタール", "sc": "卡塔尔", "tc": "卡塔爾" }},
    { "code": "RE", "label": { "en": "Réunion", "jp": "レユニオン", "sc": "留尼汪", "tc": "留尼汪" }},
    { "code": "RO", "label": { "en": "Romania", "jp": "ルーマニア", "sc": "罗马尼亚", "tc": "羅馬尼亞" }},
    { "code": "RS", "label": { "en": "Serbia", "jp": "セルビア", "sc": "塞尔维亚", "tc": "塞爾維亞" }},
    { "code": "RU", "label": { "en": "Russia", "jp": "ロシア", "sc": "俄罗斯", "tc": "俄羅斯" }},
    { "code": "RW", "label": { "en": "Rwanda", "jp": "ルワンダ", "sc": "卢旺达", "tc": "盧旺達" }},
    { "code": "SA", "label": { "en": "Saudi Arabia", "jp": "サウジアラビア", "sc": "沙特阿拉伯", "tc": "沙特阿拉伯" }},
    { "code": "SB", "label": { "en": "Solomon Islands", "jp": "ソロモン諸島", "sc": "所罗门群岛", "tc": "所羅門群島" }},
    { "code": "SC", "label": { "en": "Seychelles", "jp": "セーシェル", "sc": "塞舌尔", "tc": "塞舌爾" }},
    { "code": "SD", "label": { "en": "Sudan", "jp": "スーダン", "sc": "苏丹", "tc": "蘇丹" }},
    { "code": "SE", "label": { "en": "Sweden", "jp": "スウェーデン", "sc": "瑞典", "tc": "瑞典" }},
    { "code": "SG", "label": { "en": "Singapore", "jp": "シンガポール", "sc": "新加坡", "tc": "新加坡" }},
    { "code": "SH", "label": { "en": "Saint Helena", "jp": "セントヘレナ", "sc": "圣赫勒拿", "tc": "聖赫勒拿" }},
    { "code": "SI", "label": { "en": "Slovenia", "jp": "スロベニア", "sc": "斯洛文尼亚", "tc": "斯洛文尼亞" }},
    { "code": "SJ", "label": { "en": "Svalbard and Jan Mayen", "jp": "スバールバル諸島とヤンマイエン", "sc": "斯瓦尔巴和扬马延", "tc": "斯瓦爾巴和揚馬延" }},
    { "code": "SK", "label": { "en": "Slovakia", "jp": "スロバキア", "sc": "斯洛伐克", "tc": "斯洛伐克" }},
    { "code": "SL", "label": { "en": "Sierra Leone", "jp": "シエラレオネ", "sc": "塞拉利昂", "tc": "塞拉利昂" }},
    { "code": "SM", "label": { "en": "San Marino", "jp": "サンマリノ", "sc": "圣马力诺", "tc": "聖馬利諾" }},
    { "code": "SN", "label": { "en": "Senegal", "jp": "セネガル", "sc": "塞内加尔", "tc": "塞內加爾" }},
    { "code": "SO", "label": { "en": "Somalia", "jp": "ソマリア", "sc": "索马里", "tc": "索馬利" }},
    { "code": "SR", "label": { "en": "Suriname", "jp": "スリナム", "sc": "苏里南", "tc": "蘇里南" }},
    { "code": "SS", "label": { "en": "South Sudan", "jp": "南スーダン", "sc": "南苏丹", "tc": "南蘇丹" }},
    { "code": "ST", "label": { "en": "Sao Tome and Principe", "jp": "サントメ・プリンシペ", "sc": "圣多美和普林西比", "tc": "聖多美和普林西比" }},
    { "code": "SV", "label": { "en": "El Salvador", "jp": "エルサルバドル", "sc": "萨尔瓦多", "tc": "薩爾瓦多" }},
    { "code": "SX", "label": { "en": "Sint Maarten", "jp": "シント・マールテン", "sc": "荷属圣马丁", "tc": "荷屬聖馬丁" }},
    { "code": "SY", "label": { "en": "Syria", "jp": "シリア", "sc": "叙利亚", "tc": "敘利亞" }},
    { "code": "SZ", "label": { "en": "Eswatini", "jp": "エスワティニ", "sc": "斯威士兰", "tc": "史瓦帝尼" }},
    { "code": "TC", "label": { "en": "Turks and Caicos Islands", "jp": "タークス・カイコス諸島", "sc": "特克斯和凯科斯群岛", "tc": "特克斯和凱科斯群島" }},
    { "code": "TD", "label": { "en": "Chad", "jp": "チャド", "sc": "乍得", "tc": "乍得" }},
    { "code": "TF", "label": { "en": "French Southern Territories", "jp": "フランス領南方・南極地域", "sc": "法属南方和南极地区", "tc": "法屬南方和南極地區" }},
    { "code": "TG", "label": { "en": "Togo", "jp": "トーゴ", "sc": "多哥", "tc": "多哥" }},
    { "code": "TH", "label": { "en": "Thailand", "jp": "タイ", "sc": "泰国", "tc": "泰國" }},
    { "code": "TJ", "label": { "en": "Tajikistan", "jp": "タジキスタン", "sc": "塔吉克斯坦", "tc": "塔吉克斯坦" }},
    { "code": "TK", "label": { "en": "Tokelau", "jp": "トケラウ", "sc": "托克劳", "tc": "托克勞" }},
    { "code": "TL", "label": { "en": "Timor-Leste", "jp": "東ティモール", "sc": "东帝汶", "tc": "東帝汶" }},
    { "code": "TM", "label": { "en": "Turkmenistan", "jp": "トルクメニスタン", "sc": "土库曼斯坦", "tc": "土庫曼斯坦" }},
    { "code": "TN", "label": { "en": "Tunisia", "jp": "チュニジア", "sc": "突尼斯", "tc": "突尼斯" }},
    { "code": "TO", "label": { "en": "Tonga", "jp": "トンガ", "sc": "汤加", "tc": "湯加" }},
    { "code": "TR", "label": { "en": "Turkey", "jp": "トルコ", "sc": "土耳其", "tc": "土耳其" }},
    { "code": "TT", "label": { "en": "Trinidad and Tobago", "jp": "トリニダード・トバゴ", "sc": "特立尼达和多巴哥", "tc": "特立尼達和多巴哥" }},
    { "code": "TV", "label": { "en": "Tuvalu", "jp": "ツバル", "sc": "图瓦卢", "tc": "圖瓦盧" }},
    { "code": "TZ", "label": { "en": "Tanzania", "jp": "タンザニア", "sc": "坦桑尼亚", "tc": "坦尚尼亞" }},
    { "code": "UA", "label": { "en": "Ukraine", "jp": "ウクライナ", "sc": "乌克兰", "tc": "烏克蘭" }},
    { "code": "UG", "label": { "en": "Uganda", "jp": "ウガンダ", "sc": "乌干达", "tc": "烏干達" }},
    { "code": "UM", "label": { "en": "U.S. Minor Outlying Islands", "jp": "アメリカ合衆国の小離島", "sc": "美国本土外小岛屿", "tc": "美國本土外小離島" }},
    { "code": "UN", "label": { "en": "United Nations", "jp": "国際連合", "sc": "联合国", "tc": "聯合國" }},
    { "code": "US", "label": { "en": "United States", "jp": "アメリカ合衆国", "sc": "美国", "tc": "美國" }},
    { "code": "UY", "label": { "en": "Uruguay", "jp": "ウルグアイ", "sc": "乌拉圭", "tc": "烏拉圭" }},
    { "code": "UZ", "label": { "en": "Uzbekistan", "jp": "ウズベキスタン", "sc": "乌兹别克斯坦", "tc": "烏茲別克" }},
    { "code": "VA", "label": { "en": "Vatican City", "jp": "バチカン市国", "sc": "梵蒂冈", "tc": "梵蒂岡" }},
    { "code": "VC", "label": { "en": "Saint Vincent and the Grenadines", "jp": "セントビンセントおよびグレナディーン諸島", "sc": "圣文森特和格林纳丁斯", "tc": "聖文森特和格林納丁斯" }},
    { "code": "VE", "label": { "en": "Venezuela", "jp": "ベネズエラ", "sc": "委内瑞拉", "tc": "委內瑞拉" }},
    { "code": "VG", "label": { "en": "British Virgin Islands", "jp": "イギリス領バージン諸島", "sc": "英属维尔京群岛", "tc": "英屬維爾京群島" }},
    { "code": "VI", "label": { "en": "U.S. Virgin Islands", "jp": "アメリカ領ヴァージン諸島", "sc": "美属维尔京群岛", "tc": "美屬維爾京群島" }},
    { "code": "VN", "label": { "en": "Vietnam", "jp": "ベトナム", "sc": "越南", "tc": "越南" }},
    { "code": "VU", "label": { "en": "Vanuatu", "jp": "バヌアツ", "sc": "瓦努阿图", "tc": "瓦努阿圖" }},
    { "code": "WF", "label": { "en": "Wallis and Futuna", "jp": "ウォリス・フツナ", "sc": "瓦利斯和富图纳", "tc": "瓦利斯和富圖納" }},
    { "code": "WS", "label": { "en": "Samoa", "jp": "サモア", "sc": "萨摩亚", "tc": "薩摩亞" }},
    { "code": "YE", "label": { "en": "Yemen", "jp": "イエメン", "sc": "也门", "tc": "也門" }},
    { "code": "YT", "label": { "en": "Mayotte", "jp": "マヨット", "sc": "马约特", "tc": "馬約特" }},
    { "code": "ZA", "label": { "en": "South Africa", "jp": "南アフリカ", "sc": "南非", "tc": "南非" }},
    { "code": "ZM", "label": { "en": "Zambia", "jp": "ザンビア", "sc": "赞比亚", "tc": "贊比亞" }},
    { "code": "ZW", "label": { "en": "Zimbabwe", "jp": "ジンバブエ", "sc": "津巴布韦", "tc": "津巴布韋" }}
]
  
export const PLACE_SORT_OPTIONS = {
    NAME: {
        en: "Name",
        jp: "名前",
        tc: "名稱",
        sc: "名称",
    },
    LOCATION: {
        en: "Location",
        jp: "場所",
        tc: "地點",
        sc: "地点",
    },
    RATING: {
        en: "Rating",
        jp: "評価",
        tc: "評分",
        sc: "评分",
    },
    VIEWS: {
        en: "Views",
        jp: "閲覧数",
        tc: "瀏覽數",
        sc: "浏览数",
    },
    DATE_CREATED: {
        en: "Date Created",
        jp: "作成日",
        tc: "建立日期",
        sc: "创建日期",
    }
};
  